var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import { DropdownOption } from '../../definitions/formItem/ElementConfig';
var AbstractPromoCode = /** @class */ (function () {
    function AbstractPromoCode(obj, id) {
        if (id) {
            this.id = id;
        }
        this.code = obj.code;
        if (obj.begin_date !== "undefined") {
            this.begin_date = obj.begin_date;
        }
        if (obj.end_date !== "undefined") {
            this.end_date = obj.end_date;
        }
    }
    Object.defineProperty(AbstractPromoCode.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractPromoCode.prototype, "Code", {
        get: function () {
            return this.code;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractPromoCode.prototype, "BeginDate", {
        get: function () {
            return this.begin_date;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractPromoCode.prototype, "EndDate", {
        get: function () {
            return this.end_date;
        },
        enumerable: false,
        configurable: true
    });
    return AbstractPromoCode;
}());
export { AbstractPromoCode };
var PromoCodeListItem = /** @class */ (function (_super) {
    __extends(PromoCodeListItem, _super);
    function PromoCodeListItem(obj, id) {
        var _this = _super.call(this, obj, id) || this;
        _this.discount_value = obj.discount_value;
        _this.discount_type = obj.discount_type;
        return _this;
    }
    Object.defineProperty(PromoCodeListItem.prototype, "DiscountValue", {
        get: function () {
            return this.discount_value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCodeListItem.prototype, "DiscountType", {
        get: function () {
            return this.discount_type;
        },
        enumerable: false,
        configurable: true
    });
    return PromoCodeListItem;
}(AbstractPromoCode));
export { PromoCodeListItem };
var PromoCode = /** @class */ (function () {
    function PromoCode(obj, id) {
        if (id) {
            this.id = id;
        }
        this.code = obj.code;
        if (obj.begin_date !== "undefined") {
            this.begin_date = obj.begin_date;
        }
        if (obj.begin_date_time !== "undefined") {
            this.begin_date_time = obj.begin_date_time;
        }
        if (obj.end_date !== "undefined") {
            this.end_date = obj.end_date;
        }
        if (obj.end_date_time !== "undefined") {
            this.end_date_time = obj.end_date_time;
        }
        if (obj.only_logged_users !== "undefined") {
            this.only_logged_users = obj.only_logged_users;
        }
        this.maximum_uses = obj.maximum_uses;
        this.discount_type = obj.discount_type;
        this.discount_value = obj.discount_value;
        this.unique_per_user = obj.unique_per_user;
        this.brand_ids = this.getBrandIds(obj.brand_ids);
        this.category_id = Number(_.get(obj, 'category_id.value', _.get(obj, 'category_id')));
    }
    PromoCode.prototype.getBrandIds = function (rawBrands) {
        var brandsIds = [];
        for (var _i = 0, rawBrands_1 = rawBrands; _i < rawBrands_1.length; _i++) {
            var cat = rawBrands_1[_i];
            brandsIds.push(Number(cat.value));
        }
        return brandsIds;
    };
    Object.defineProperty(PromoCode.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCode.prototype, "Code", {
        get: function () {
            return this.code;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCode.prototype, "CategoryId", {
        get: function () {
            return this.category_id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCode.prototype, "BeginDate", {
        get: function () {
            return this.begin_date;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCode.prototype, "BeginDateTime", {
        get: function () {
            return this.begin_date_time;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCode.prototype, "EndDate", {
        get: function () {
            return this.end_date;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCode.prototype, "EndDateTime", {
        get: function () {
            return this.end_date_time;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCode.prototype, "OnlyLoggedUsers", {
        get: function () {
            return this.only_logged_users;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCode.prototype, "MaximumUses", {
        get: function () {
            return this.maximum_uses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCode.prototype, "DiscountType", {
        get: function () {
            return this.discount_type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCode.prototype, "DiscountValue", {
        get: function () {
            return this.discount_value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCode.prototype, "UniquePerUser", {
        get: function () {
            return this.unique_per_user;
        },
        enumerable: false,
        configurable: true
    });
    return PromoCode;
}());
export { PromoCode };
var PromoCodeEdit = /** @class */ (function () {
    function PromoCodeEdit(obj, id) {
        if (id) {
            this.id = id;
        }
        this.code = obj.code;
        if (obj.begin_date !== "undefined") {
            this.begin_date = obj.begin_date;
        }
        if (obj.begin_date_time !== "undefined") {
            this.begin_date_time = obj.begin_date_time;
        }
        if (obj.end_date !== "undefined") {
            this.end_date = obj.end_date;
        }
        if (obj.end_date_time !== "undefined") {
            this.end_date_time = obj.end_date_time;
        }
        if (obj.only_logged_users !== "undefined") {
            this.only_logged_users = obj.only_logged_users;
        }
        this.maximum_uses = obj.maximum_uses;
        this.discount_type = obj.discount_type;
        this.discount_value = obj.discount_value;
        this.unique_per_user = obj.unique_per_user;
        this.brands_name = this.getBrandsName(obj.brands);
        this.category_id = obj.category
            ? new DropdownOption({
                label: _.get(obj, 'category.attributes.bg_name') + " (" + _.get(obj, 'category.attributes.slug') + ")",
                value: _.get(obj, 'category.id'),
            })
            : null;
    }
    PromoCodeEdit.prototype.getBrandsName = function (rawBrands) {
        var brandsIds = [];
        for (var _i = 0, rawBrands_2 = rawBrands; _i < rawBrands_2.length; _i++) {
            var cat = rawBrands_2[_i];
            brandsIds.push(new DropdownOption({
                label: _.get(cat, 'attributes.name') + " (" + _.get(cat, 'attributes.slug') + ")",
                value: _.get(cat, 'id'),
            }));
        }
        return brandsIds;
    };
    Object.defineProperty(PromoCodeEdit.prototype, "BrandsName", {
        get: function () {
            return this.brands_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCodeEdit.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCodeEdit.prototype, "Code", {
        get: function () {
            return this.code;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCodeEdit.prototype, "BeginDate", {
        get: function () {
            return this.begin_date;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCodeEdit.prototype, "BeginDateTime", {
        get: function () {
            return this.begin_date_time;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCodeEdit.prototype, "EndDate", {
        get: function () {
            return this.end_date;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCodeEdit.prototype, "EndDateTime", {
        get: function () {
            return this.end_date_time;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCodeEdit.prototype, "OnlyLoggedUsers", {
        get: function () {
            return this.only_logged_users;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCodeEdit.prototype, "MaximumUses", {
        get: function () {
            return this.maximum_uses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCodeEdit.prototype, "DiscountType", {
        get: function () {
            return this.discount_type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCodeEdit.prototype, "DiscountValue", {
        get: function () {
            return this.discount_value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCodeEdit.prototype, "UniquePerUser", {
        get: function () {
            return this.unique_per_user;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoCodeEdit.prototype, "CategoryFormatted", {
        get: function () {
            return this.category_id;
        },
        enumerable: false,
        configurable: true
    });
    return PromoCodeEdit;
}());
export { PromoCodeEdit };
export function createPromoCode(obj, id) {
    // Check if `category_id` exists and is a falsy value, set it to null if it's `0`
    if (obj.category_id === 0) {
        obj.category_id = null;
    }
    return new PromoCode(obj, id);
}
export function createPromoCodeEdit(obj, id) {
    return new PromoCodeEdit(obj, id);
}
export function createPromoCodeListItem(obj, id) {
    return new PromoCodeListItem(obj, id);
}
export function createPromoCodes(rawCodes) {
    var codes = [];
    var rawCodesData = rawCodes.data;
    for (var _i = 0, rawCodesData_1 = rawCodesData; _i < rawCodesData_1.length; _i++) {
        var rawCode = rawCodesData_1[_i];
        var code = createPromoCodeListItem(rawCode.attributes, rawCode.id);
        codes.push(code);
    }
    return codes;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/promoCode/promoCode.ts
// module id = 124
// module chunks = 0